import React from "react"
import { connect } from "react-redux"
import CartLabels from "./CartLabels"
import CartListProduct from "./CartListProduct"
import EmptyBasket from "./EmptyBasket"
import S from "./CartList.module.scss"

const CartList = ({ cart }) => {
  if (cart.length > 0) {
    return (
      <div className={S.cartlist}>
        <CartLabels />
        {cart.map(product => {
          const { id, name, image, price, quantity, size } = product
          return (
            <CartListProduct
              key={id}
              id={id}
              name={name}
              image={image.fluid}
              price={price}
              quantity={quantity}
              size={size}
            />
          )
        })}
      </div>
    )
  } else {
    return (
      <>
        <EmptyBasket />
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    cart: state.shoppingCart.products,
  }
}

export default connect(mapStateToProps)(CartList)
